const AdminPage = () => {
  return <h1>Admin Dashboard</h1>;
};

export default AdminPage;
